import { render, staticRenderFns } from "./SearchInherit.vue?vue&type=template&id=76d1a084&"
import script from "./SearchInherit.vue?vue&type=script&lang=js&"
export * from "./SearchInherit.vue?vue&type=script&lang=js&"
import style0 from "./SearchInherit.vue?vue&type=style&index=0&id=76d1a084&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports